import { ComponentsVariants, isVariantOf } from '@/components.variants';
import { EsTabbedContentProps } from '@/features/shared/portal/EsTabbedContent/EsTabbedContent.interfaces';
import { get, getOr, map, pipe } from 'lodash/fp';

export const isEsTabbedContent = isVariantOf(ComponentsVariants.ES_TABBED_CONTENT, true);

export default (rawVal: any, page: any, pageModels: any) => {
  return {
    variant: ComponentsVariants.ES_TABBED_CONTENT,
    tabContent: pipe(
      getOr([], 'tabContent'),
      map((tabContent: any) => ({
        keys: tabContent?.keys,
        size: tabContent?.size,
        sortBy: tabContent?.sortby,
        tabTitle: tabContent?.tabTitle,
      })),
    )(rawVal),
    className: get('className', rawVal),
    theme: get('className', rawVal),
  } as EsTabbedContentProps;
};
